import React from "react";

export default function TermsOfServiceEn() {
  return (
    <>
      <h1>TERMS OF SERVICE OF LIGAVIRTUALF1</h1>
      <p>
        <strong>Last Updated:</strong> June 2026
      </p>

      <p>
        Welcome to <strong>LigaVirtualF1</strong> (hereinafter, "the Community",
        "we", "us", or "the Platform"), accessible via the web address:{" "}
        <a
          href="https://ligavirtualf1.es/en"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://ligavirtualf1.es/en
        </a>
        .
      </p>

      <p>
        By registering on our website, participating in our simracing
        championships, or using any of our services, you agree to comply with
        and be bound by the following Terms of Service. If you do not agree with
        any part of these terms, please do not use our platform or participate
        in our activities.
      </p>

      <hr
        style={{
          border: "0",
          height: "1px",
          background: "#ccc",
          margin: "20px 0",
        }}
      />

      <h3>1. NATURE OF THE SERVICE</h3>
      <p>
        LigaVirtualF1 is a non-profit online community dedicated to the
        organization, management, and enjoyment of simracing (virtual
        motorsport) championships. The platform provides a gathering space,
        statistics tracking, and coordination for virtual racing enthusiasts
        completely free of charge.
      </p>

      <h3>2. ACCOUNT REGISTRATION AND SECURITY</h3>
      <p>
        To actively participate in the community and championships, users must
        create an account. During registration, we request the following data:
      </p>
      <ul>
        <li>
          <strong>Required Data:</strong> First name, last name, username
          (Nick), email address, country (and autonomous community if Spain is
          selected), password, and how you found out about us.
        </li>
        <li>
          <strong>Optional Data:</strong> Date of birth and profile picture.
        </li>
      </ul>

      <p>By registering, you agree to:</p>
      <ul>
        <li>Provide accurate, truthful information and keep it up to date.</li>
        <li>
          Be responsible for the security of your password. LigaVirtualF1 is not
          liable for any unauthorized access due to user negligence.
        </li>
        <li>Not create fake accounts or impersonate other drivers or users.</li>
      </ul>

      <p className="note">
        <em>
          (For more information on how we protect and process your personal
          data, please refer to our Privacy Policy in accordance with the GDPR
          of Spain and the European Union).
        </em>
      </p>
      <h3>3. CODE OF CONDUCT AND COMMUNITY GUIDELINES</h3>
      <p>
        The foundation of LigaVirtualF1 is fair play and mutual respect, both on
        and off the track. The following are strictly prohibited:
      </p>
      <ul>
        <li>
          The use of insults, hate speech, racism, xenophobia, or harassment
          through forums, comments, profiles, or official community channels
          (including voice servers like Discord).
        </li>
        <li>
          The use of malicious software, hacking tools, unauthorized competitive
          advantages (<em>cheats</em>), or any method that alters the website
          code or fair performance within the simulators.
        </li>
        <li>
          Publishing offensive, pornographic, or illegal content in profile
          pictures or usernames.
        </li>
      </ul>
      <p>
        <strong>Sanctions:</strong> LigaVirtualF1 reserves the right to suspend,
        ban, or permanently delete the account of any user and restrict their
        participation in championships if these rules are violated, without
        prior notice.
      </p>

      <h3>4. INTELLECTUAL PROPERTY</h3>
      <ul>
        <li>
          <strong>Community Content:</strong> Original logos, web design,
          informative texts, and the general structure of LigaVirtualF1 are the
          exclusive property of the community administration and may not be
          reproduced or used without prior consent.
        </li>
        <li>
          <strong>Third-Party Libraries:</strong> This website uses open-source
          resources and third-party libraries (such as <em>Chart.js</em> for
          data visualization). The rights to these tools belong to their
          respective authors under their own open-source software licenses.
        </li>
        <li>
          <strong>Video Game and YouTube Content:</strong> Race videos, live
          streams, or images uploaded to platforms like YouTube contain
          intellectual property owned by the developers of the simulators and/or
          the Formula One Administration (if applicable). LigaVirtualF1 uses
          these elements solely for recreational, informative, and community
          entertainment purposes, respecting the content-sharing policies of the
          game creators.
        </li>
      </ul>

      <h3>5. LIMITATION OF LIABILITY</h3>
      <p>
        Given that LigaVirtualF1 is a completely free and recreational platform:
      </p>
      <ul>
        <li>
          The service is provided on an "as is" and "as available" basis. We do
          not guarantee that the website will be operational 100% of the time.
          We are not responsible for data loss regarding standings, server
          crashes, interruptions during racing sessions, or technical issues
          beyond our control.
        </li>
        <li>
          Since there are no commercial transactions or lucrative activities
          involved, the Community is exempt from any liability for alleged
          economic or personal damages arising from the use of the website or
          participation in the virtual leagues.
        </li>
      </ul>

      <h3>6. MODIFICATIONS TO THE TERMS</h3>
      <p>
        We reserve the right to modify these Terms of Service at any time to
        adapt them to new legal regulations, technical changes on the website,
        or new championship dynamics. We will notify users of major updates via
        the website homepage or through the organization's social media
        channels. Continued use of the website after modifications implies
        acceptance of the new terms.
      </p>

      <h3>7. GOVERNING LAW AND JURISDICTION</h3>
      <p>
        These Terms of Service are governed by Spanish law. Any dispute or
        controversy related to the use of this website shall be submitted to the
        competent courts and tribunals in Spain.
      </p>
    </>
  );
}
